<mvs-launchpad-base *ngIf="moduleAlias" [moduleAlias]="moduleAlias"></mvs-launchpad-base>
<mvs-guided-tour *ngIf="moduleAlias" [moduleAlias]="moduleAlias"></mvs-guided-tour>
